export default {
    data() {
        return {
            windowWidth: window.innerWidth,
        }
    },

    computed: {
        isMobile() {
            return this.windowWidth <= 400
        },

        isMobileLarge() {
            return this.windowWidth <= 600
        },

        isTablet() {
            return this.windowWidth <= 1024
        },

        isTabletSmall() {
            return this.windowWidth <= 820
        },

        isLaptop() {
            return this.windowWidth <= 1440
        },

        isMasterUserAndRegisteredPractice() {
            return this.$auth.getUser().isMasterUser && this.$auth.getPractice().masterUserId === this.$auth.getUser().id
        },
    },

    methods: {
        calculateWindowWidth() {
            this.windowWidth = window.innerWidth
        },
    },

    mounted() {
        window.addEventListener('resize', this.calculateWindowWidth)
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.calculateWindowWidth)
    },
}
